import { type RouteLocationNormalized, type RouteRecordRaw } from 'vue-router'

export const snapshotHistoryRouter: RouteRecordRaw[] = [
  {
    component: async () =>
      await import('../components/snapshots/SnapshotHistory.vue'),
    name: 'snapshotHistory',
    path: 'snapshot-history/:menuId',
    props: (route: RouteLocationNormalized) => ({
      menuId: route.params.menuId as string,
    }),
  },
]

export const snapshotDiffRouter: RouteRecordRaw[] = [
  {
    component: async () =>
      await import('../components/snapshots/SnapshotDiffPage.vue'),
    name: 'snapshotDiff',
    path: 'snapshot-diff/:menuId/:snapshotAId/:snapshotBId',
    props: (route: RouteLocationNormalized) => ({
      menuId: route.params.menuId as string,
      snapshotAId: route.params.snapshotAId as string,
      snapshotBId: route.params.snapshotBId as string,
    }),
  },
]
